// extracted by mini-css-extract-plugin
module.exports = {"image":"PicaImage-image-d93d"};